export default "__VITE_PUBLIC_ASSET__aca6ae87__"